<template>
  <div class="px-3 mt-2 bg-white pb-8" style="min-height: calc(100vh - 75px)">
    <h3 class="text-premier-blue text-uppercase font-rubik-medium pt-4 mb-4">
      Informasi Pasien
    </h3>
    <div class="row">
      <div class="col-6">
        <b-form-group id="register-first-name-group" class="form-login-register" label-for="register-first-name">
          <template #label>
            Nama depan <span class="text-danger">*</span>
          </template>
          <b-form-input
            id="register-first-name"
            v-model="$v.form.firstname.$model"
            name="register-first-name"
            aria-describedby="register-first-name-feedback"
            :state="validateState('firstname')"
            type="text"
            required
            autofocus
          />
          <b-form-invalid-feedback
            id="register-first-name-feedback"
          >
            Tolong isi nama depan Anda minimal 3 huruf
          </b-form-invalid-feedback>
        </b-form-group>
      </div>
      <div class="col-6">
        <b-form-group id="register-last-name-group" class="form-login-register" label="Nama belakang" label-for="register-last-name">
          <b-form-input
            id="register-last-name"
            v-model="$v.form.lastname.$model"
            aria-describedby="last-name-field-feedback"
            :state="validateState('lastname')"
            type="text"
            required
          />
          <b-form-invalid-feedback
            id="register-last-name-feedback"
          >
            Tolong isi nama belakang Anda dengan huruf
          </b-form-invalid-feedback>
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-form-group id="register-email-group" class="form-login-register" label-for="register-email">
          <template #label>
            Email <span class="text-danger">*</span>
          </template>
          <b-form-input
            id="register-email"
            v-model="$v.form.email.$model"
            :disabled="userData && !!userData.Email"
            aria-describedby="email-field-feedback"
            :state="validateState('email')"
            type="email"
            required
          />
          <b-form-invalid-feedback
            id="email-field-feedback"
          >
            Tolong isi dengan format email
          </b-form-invalid-feedback>
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-12 input-phone-number">
        <client-only>
          <vue-tel-input
            v-model="$v.form.phone.$model"
            :disabled="userData && !!userData.Phone"
            v-bind="bindProps"
            :valid-characters-only="true"
            @onInput="onInput"
            @onBlur="onBlur"
          />
        </client-only>
        <div v-if="$v.form.phone.$anyError" class="text-error mt-1">
          Tolong isi nomor whatsapp Anda
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mt-4">
        <b-form-group id="register-born-date-group" class="form-login-register" label-for="register-born-date">
          <template #label>
            Tanggal lahir <span class="text-danger">*</span>
          </template>
          <el-date-picker
            v-model="$v.form.bornDate.$model"
            :editable="false"
            class="w-100"
            popper-class="custom-date-picker"
            type="date"
            placeholder="Pilih tanggal lahir Anda"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          />
          <div v-if="$v.form.bornDate.$anyError" class="text-error mt-2">
            Tolong isi tanggal lahir Anda
          </div>
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <b-form-group id="register-height-group" class="form-login-register" label-for="register-height-name">
          <template #label>
            Tinggi <span class="text-danger">*</span>
          </template>
          <b-input-group size="sm" append="cm">
            <b-form-input
              id="register-height-name"
              v-model="$v.form.height.$model"
              aria-describedby="register-height-feedback"
              :state="validateState('height')"
              type="number"
              :formatter="maxLengthInput"
              required
            />
          </b-input-group>
          <b-form-invalid-feedback
            id="register-height-feedback"
          >
            Tolong isi tinggi Anda
          </b-form-invalid-feedback>
        </b-form-group>
      </div>
      <div class="col-4">
        <b-form-group id="register-weight-group" class="form-login-register" label-for="register-weight-group">
          <template #label>
            Berat <span class="text-danger">*</span>
          </template>
          <b-input-group size="sm" append="kg">
            <b-form-input
              id="register-weight-group"
              v-model="$v.form.weight.$model"
              aria-describedby="weight-field-feedback"
              :state="validateState('weight')"
              :formatter="maxLengthInput"
              type="number"
              required
            />
          </b-input-group>
          <b-form-invalid-feedback
            id="weight-field-feedback"
          >
            Tolong isi berat Anda
          </b-form-invalid-feedback>
        </b-form-group>
      </div>
      <div class="col-4 pl-0">
        <b-form-group id="register-blood-group" class="form-login-register" label-for="register-blood-group">
          <template #label>
            Gol. Darah <span class="text-danger">*</span>
          </template>
          <b-form-select
            id="register-blood-group"
            v-model="$v.form.bloodGroup.$model"
            aria-describedby="blood_group-field-feedback"
            :options="form.bloodGroupSelected"
            :state="validateState('bloodGroup')"
          />
          <b-form-invalid-feedback
            id="blood_group-field-feedback"
          >
            Tolong isi golongan darah Anda
          </b-form-invalid-feedback>
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-form-group id="register-gender-group" class="form-login-register" label-for="register-first-name">
          <template #label>
            Jenis Kelamin <span class="text-danger">*</span>
          </template>
          <div class="gender-selector">
            <input
              id="genderMale"
              v-model="form.gender"
              type="radio"
              name="option"
              value="Male"
              checked
            >
            <label for="genderMale">
              <div class="male">
                <template v-if="form.gender === 'Male'">
                  <img src="@/assets/img/male1.png">
                </template>
                <template v-else>
                  <img src="@/assets/img/male2.png">
                </template>
                PRIA
              </div>
            </label>
            <input id="genderFemale" v-model="form.gender" type="radio" name="option" value="Female">
            <label for="genderFemale">
              <div class="female">
                <template v-if="form.gender === 'Female'">
                  <img src="@/assets/img/female1.png">
                </template>
                <template v-else>
                  <img src="@/assets/img/female2.png">
                </template>
                WANITA
              </div>
            </label>
          </div>
        </b-form-group>
      </div>
    </div>
    <div v-if="!userData" class="row">
      <div class="col-12">
        <b-form-checkbox
          id="check_allergy"
          v-model="form.checkAllergy"
          name="check_allergy"
          :value="true"
          :unchecked-value="false"
        >
          Saya tidak memiliki alergi
        </b-form-checkbox>
      </div>
      <div v-if="!form.checkAllergy" class="col-12">
        <b-form-group id="register-first-name-group" class="form-login-register">
          <b-form-input
            id="register-allergy"
            v-model="form.allergy"
            name="register-allergy"
            type="text"
          />
        </b-form-group>
      </div>
      <div class="col-12" :class="{'mt-2': form.checkAllergy}">
        <b-form-checkbox
          id="check_consume"
          v-model="form.checkConsume"
          name="check_consume"
          :value="true"
          :unchecked-value="false"
        >
          Saya tidak mengkonsumsi obat rutin
        </b-form-checkbox>
      </div>
      <div v-if="!form.checkConsume" class="col-12">
        <select-medicines @selectedMedicines="selectedMedicines" />
      </div>
    </div>
    <div v-if="!userData" class="row mt-3">
      <div class="col-12">
        <div class="encryption-info d-flex">
          <div class="lock">
            <img src="@/assets/img/lock.png">
          </div>
          <div class="description">
            <p class="m-0">
              INI ADALAH HALAMAN TERENKRIPSI.<br>INFORMASI ANDA DI HALAMAN INI AMAN DAN TERLINDUNGI OLEH ENKRIPSI AES-256BIT
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center mt-4">
      <div v-if="!userData" class="col-12">
        <div class="row justify-content-center">
          <div class="col-10">
            <b-button
              size="lg"
              block
              variant="success-2"
              class="border-r25px"
              :disabled="isLoading"
              @click="handleSubmit()"
            >
              LANJUTKAN
              <b-spinner v-if="isLoading" small label="Small Spinner" variant="light" />
            </b-button>
          </div>
        </div>

        <p class="font-rubik-medium text-premier-blue text-center mt-4">
          Sudah punya akun? Masuk sekarang
        </p>
        <div class="row justify-content-center mb-5 pb-5">
          <div class="col-10">
            <b-button size="lg" block variant="primary-3" class="border-r25px" @click="gotoLogin()">
              MASUK
            </b-button>
          </div>
        </div>
      </div>
      <div v-else class="col-10">
        <b-button
          size="lg"
          block
          variant="success-2"
          class="border-r25px font-rubik-medium"
          :disabled="isLoading"
          @click="handleSubmit()"
        >
          Simpan
          <template v-if="!isLoading">
            <font-awesome-icon icon="chevron-right" class="mr-n2" /> <font-awesome-icon icon="chevron-right" />
          </template>
          <template v-else>
            <b-spinner small label="Small Spinner" variant="light" class="mb-1" />
          </template>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, minLength, email, helpers } from 'vuelidate/lib/validators'
import SelectMedicines from '@/components/appointment-component/SelectMedicines'

const characterValidator = helpers.regex('alphaNumAndDot', /^[a-zA-Z]*$/i)
const now = new Date()
const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
const maxDate = new Date(today)
maxDate.setMonth(maxDate.getMonth() - 84) // 7 years

export default {
  name: 'Register',
  components: {
    SelectMedicines
  },
  mixins: [validationMixin],
  data: () => ({
    form: {
      firstname: null,
      lastname: '',
      email: null,
      phone: null,
      countryCode: null,
      bornDate: null,
      height: null,
      weight: null,
      bloodGroup: null,
      bloodGroupSelected: [
        { value: null, text: '' },
        { value: 'A', text: 'A' },
        { value: 'B', text: 'B' },
        { value: 'AB', text: 'AB' },
        { value: 'O', text: 'O' }
      ],
      gender: 'Male',
      checkAllergy: false,
      checkConsume: false,
      allergy: '',
      consume: [],
      nationality: ''
    },

    checkTel: false,
    checkBornDate: false,
    isLoading: false,
    maxBornDate: maxDate,
    pickerOptions: {
      disabledDate (date) {
        const max = date.setMonth(date.getMonth() + 84)
        return Date.now() - 8.64e7 < max
      }
    },

    bindProps: {
      mode: 'international',
      defaultCountry: 'ID',
      disabledFetchingCountry: true,
      disabled: false,
      disabledFormatting: true,
      placeholder: 'Masukkan Nomor WhatsApp',
      enabledCountryCode: true,
      enabledFlags: true,
      autocomplete: 'off',
      maxLen: 25,
      wrapperClasses: '',
      inputClasses: '',
      dropdownOptions: {
        disabledDialCode: false
      },
      inputOptions: {
        showDialCode: false
      }
    }
  }),
  validations: {
    form: {
      firstname: { required, minLength: minLength(3), characterValidator },
      lastname: { characterValidator },
      email: { required, email },
      phone: { required },
      bornDate: { required },
      height: { required },
      weight: { required },
      bloodGroup: { required },
      gender: { required }
    }
  },
  computed: {
    userData () {
      return this.$store.state.patient.auth.userData
    }
  },
  mounted () {
    if (this.userData) {
      this.form.firstname = this.userData.Firstname
      this.form.lastname = this.userData.Lastname
      this.form.email = this.userData.Email
      this.form.phone = this.userData.Phone
      this.form.bornDate = this.userData.Birthdate
      this.form.height = this.userData.Height
      this.form.weight = this.userData.Weight
      this.form.bloodGroup = this.userData.BloodType
      this.form.gender = this.userData.Gender || 'Male'
    }
  },
  methods: {
    async handleSubmit () {
      this.isLoading = true
      this.$v.form.$touch()

      if (this.$v.form.$anyError) {
        if (process.client) {
          window.scrollTo(0, 0)
        }
        this.isLoading = false
        return
      }
      if (!this.userData) {
        await this.requestOtp()
      } else {
        await this.updateRegister()
      }
    },
    requestOtp () {
      if (this.form.check_allergy === 'accepted') {
        this.form.allergy = ''
      }

      if (this.form.check_consume === 'accepted') {
        this.form.consume = []
      }

      if (this.form.phone) {
        if (this.form.phone.charAt(0) === '0') {
          this.form.phone = this.form.phone.substring(1)
        }
      }

      const payload = {
        Type: 'Normal',
        TypeResponse: '',
        TypeID: 4,
        Firstname: this.form.firstname,
        Lastname: this.form.lastname,
        Password: 'da39a3ee5e6b4b0d3255bfef95601890afd80709',
        Email: this.form.email,
        Phone: this.form.phone.charAt(0) !== '+' ? this.form.countryCode + this.form.phone : this.form.phone,
        Gender: this.form.gender,
        Birthdate: this.$moment(this.form.bornDate).format('YYYY-MM-DD'),
        Nationality: this.form.nationality,
        Language: 'ID',
        Alergi: this.form.allergy,
        ObatRutin: this.form.consume,
        ReferralCode: '',
        Weight: this.form.weight,
        Height: this.form.height,
        BloodType: this.form.bloodGroup
      }

      this.$store.dispatch('patient/submitRegister', payload)
        .then((res) => {
          if (res && res.Status === 'Exist') {
            this.isLoading = false
            if (res.Message === 'Email') {
              return this.$swal({
                icon: 'error',
                text: 'Alamat Email sudah terpakai'
              })
            } else if (res.Message === 'Phone') {
              return this.$swal({
                icon: 'error',
                text: 'No. Handphone sudah terdaftar'
              })
            } else {
              return this.$swal({
                icon: 'error',
                text: res.Message
              })
            }
          }
          if (res && res.Status === 'Error') {
            this.isLoading = false
            return this.$swal({
              icon: 'error',
              text: res.Message
            })
          }

          if (res && res.Data) {
            this.isLoading = false
            this.$store.commit('patient/SET_USER_WHATSAPP', this.form.phone.charAt(0) !== '+' ? this.form.countryCode + this.form.phone : this.form.phone)
            localStorage.setItem('token', res.Data.Token)
            return this.handleNext()
          }

          this.isLoading = false
        })
        .catch((err) => {
          this.isLoading = false
          throw new Error(err)
        })
    },
    updateRegister () {
      const payload = {
        Firstname: this.form.firstname,
        Lastname: this.form.lastname,
        Email: this.form.email,
        Gender: this.form.gender,
        Birthdate: this.$moment(this.form.bornDate).format('YYYY-MM-DD'),
        Weight: this.form.weight,
        Height: this.form.height,
        BloodType: this.form.bloodGroup
      }

      this.$store.dispatch('patient/updateRegister', payload)
        .then((res) => {
          if (res && res.Status === 'Error') {
            this.isLoading = false
            return this.$swal({
              icon: 'error',
              text: res.Message
            })
          }
          this.$store.commit('doctor/SET_STEP', 'confirmation')
          localStorage.setItem('step', 'confirmation')
          this.isLoading = false
        })
        .catch((err) => {
          this.isLoading = false
          throw new Error(err)
        })
    },
    handleNext () {
      this.$store.commit('doctor/SET_STEP', 'register-otp')
      localStorage.setItem('step', 'register-otp')
    },
    gotoLogin () {
      this.$store.commit('doctor/SET_STEP', 'login')
      localStorage.setItem('step', 'login')
    },
    validateState (name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    onInput ({ number, isValid, country }) {
      if (this.form.phone.charAt(0) === '0') {
        this.form.phone = this.form.phone.substring(1).replace(/-/g, '')
      }
      if (isValid) {
        if (this.form.phone.charAt(0) === '0') {
          this.form.phone = this.form.phone.substring(1)
        }
        this.form.phone = number.input.replace(/-/g, '')
        this.form.nationality = country.iso2
      }
      this.form.countryCode = '+' + country.dialCode
    },
    onBlur () {
      if (this.form.phone) {
        if (this.form.phone.charAt(0) === '0') {
          this.form.phone = this.form.phone.substring(1)
        }
      }
    },
    maxLengthInput (e) {
      return String(e).substring(0, 3)
    },
    selectedMedicines (data) {
      this.form.consume = data
    }
  }
}
</script>

<style lang="scss">
  .encryption-info {
    background: #2FB43D;
    color: #fff;
    border-radius: 4px;
    padding: 10px;
    .lock {
      width: 40px;
      padding: 5px;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 100%;
      }
    }
    .description {
      width: calc(100% - 50px);
      font-size: 14px;
      justify-content: center;
      align-items: center;
      padding-left: 10px;
    }
  }
  .text-error{
    color: red;
    font-size: 13px;
  }
  .input-group-text {
    background: transparent;
    border: 0;
    border-bottom: 0.7px solid #024668;
    border-radius: 0 !important;
  }
  .gender-selector {
    background: #BCECF0;
    border-radius: 30px;
    display: flex;
    justify-content: space-between;
    padding: 5px;
    align-items: center;

    .male {
      color: #024668;
      border-radius: 30px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        margin-right: 7px;
      }

    }
    .female {
      color: #DA00AE;
      border-radius: 30px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        margin-right: 5px;
      }
    }
    label {
      width: 50%;
      margin-bottom: 0;
    }
    svg {
      width: 30px;
      height: 30px;
    }
  }
  .gender-selector > input[type="radio"] {
    display:none;
  }
  .gender-selector > input[type="radio"]:checked + label .male {
    color: #fff;
    background: #004569;
    padding: 10px 0;
  }
  .gender-selector > input[type="radio"]:checked + label .female {
    color: #fff;
    background: #DA00AE;
    padding: 5px 0;
  }
</style>
